export default () => ({
  instances: null,
  editingInstance: null,
  loading: false,
  page: 0,
  sortBy: "name",
  orderBy: "asc",
  search: "",
});
